module.exports = __webpack_public_path__ + "img/banner-fixed.8fe25b09.jpg";